module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "module-brand"
  }, [_c('left-ad', {
    attrs: {
      "qyLeftUpAdv": _vm.qyLeftUpAdv,
      "qyLeftDownAdv": _vm.qyLeftDownAdv
    }
  }), _vm._v(" "), _c('middle-ad', {
    attrs: {
      "qyMiddleUpAdv": _vm.qyMiddleUpAdv,
      "qyMiddleMiddleAdv": _vm.qyMiddleMiddleAdv,
      "qyMiddleDownAdv": _vm.qyMiddleDownAdv
    }
  }), _vm._v(" "), _c('right-ad', {
    attrs: {
      "qyRightGoodsAdv": _vm.qyRightGoodsAdv
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("企业品牌")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19fb4b39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/brand/index.vue
// module id = 1541
// module chunks = 1